import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { doctorInfo } from '../mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 dark:bg-slate-950 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4">
              {doctorInfo.name}
            </h3>
            <p className="text-gray-400 mb-4">
              {doctorInfo.qualification}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('top')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact Information</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">{doctorInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <a href={`tel:${doctorInfo.phone}`} className="text-gray-400 hover:text-blue-400 transition-colors text-sm">
                  {doctorInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <a href={`mailto:${doctorInfo.email}`} className="text-gray-400 hover:text-blue-400 transition-colors text-sm break-all">
                  {doctorInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                <div className="text-gray-400 text-sm">
                  <p>Mon–Sat In-Person: 5:00 PM – 8:00 PM</p>
                  <p>Mon–Sat Online: 9:00 PM – 9:30 PM</p>
                  <p>Sunday: Closed</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Google Maps Section */}
        <div className="mb-8">
          <h4 className="text-lg font-semibold text-white mb-4 text-center">Our Location</h4>
          <div className="rounded-lg overflow-hidden shadow-lg">
            <iframe
              title="Kawedia Hospital and Clinic Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1891.5!2d73.8782608!3d18.5070645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c065a7c56561%3A0xe2a767f93e2765ea!2sKawedia%20Hospital%20%26%20Clinic!5e0!3m2!1sen!2sin!4v1708531234567"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <p className="text-center text-gray-400 text-sm mt-3">
            Kawedia Hospital & Clinic, 2144, MG Road, opp. Poolgate Police Chowky, New Modikhana, Pune 411001
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} {doctorInfo.name}. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mt-2">
            {doctorInfo.hospitalName} | {doctorInfo.location}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
